import { memo, useRef } from 'react';
import { MDSButton, MDSIcon, MDSSnackbar } from '@marqvision/mds-v2';
import { getIcon } from '../ListingComment/@utils';

type SimpleFileUploaderProps = {
  fileList: string[];
  isDisabled: boolean;
  onChange: (files: File[]) => Promise<void>;
};

export const SimpleFileUploader = memo((props: SimpleFileUploaderProps) => {
  const { isDisabled, onChange, fileList } = props;
  const inputRef = useRef<HTMLInputElement>(null);
  const handleAttachButtonClick = () => {
    inputRef.current?.click();
  };
  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    if (files.length + (fileList?.length || 0) > 5) {
      MDSSnackbar({
        title: 'A maximum of 5 files can be attached.',
        type: 'error',
      });
      return;
    }
    // fileList 중복 제거
    const newFiles = files.filter((file) => !fileList.includes(file.name));

    await onChange(newFiles);
    if (inputRef.current) {
      inputRef.current.value = '';
    }
  };
  return (
    <>
      <MDSButton
        variant="border"
        color="bluegray"
        isDisabled={isDisabled}
        startIcon={<MDSIcon.Upload />}
        onClick={handleAttachButtonClick}
      >
        Attach file
      </MDSButton>
      <input multiple type="file" ref={inputRef} onChange={handleFileChange} style={{ display: 'none' }} />
    </>
  );
});
SimpleFileUploader.displayName = 'SimpleFileUploader';

///------------------------------------------------------------------------------

type FileChipProps = {
  file: File;
  isUploading: boolean;
  onDelete: () => void;
};
export const FileChip = memo((props: FileChipProps) => {
  const { file, isUploading, onDelete } = props;

  const icon = getIcon(file.name);

  return (
    <MDSButton
      variant="tint"
      color="bluegray"
      isDisabled={isUploading}
      isLoading={isUploading}
      startIcon={icon}
      endIcon={<MDSIcon.CloseDelete variant="border" onClick={isUploading ? undefined : onDelete} />}
    >
      {file.name}
    </MDSButton>
  );
});
FileChip.displayName = 'FileChip';
